import React, { useState } from 'react';
import API from '../../../../utils/api';
import Iconify from '../../../Iconify';
import usePaymentStore from '../../shared/store/use-payment-store';
import { showModalError } from '../../shared/components/modals/modal-error';
import { waitUserCancelCashoutsPending } from '../../shared/utils/cashouts';
import styles from './cash.module.css';
import iconoTienda from '../../shared/assets/icono-tienda.png';
import iconoBotonDescargaFicha from '../../shared/assets/icono-boton-descarga-tu-ficha.png';
import iconoDisclaimer from '../../shared/assets/icono-disclaimer.png';

export const CashConekta = () => {
  const { amount, isInvalidAmount } = usePaymentStore();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [order, setOrder] = useState(null);

  const processPayment = async () => {
    setIsSubmitting(true);
    try {
      const userCancell  = await waitUserCancelCashoutsPending({
        buttonConfirm: 'Generar Referencia',
        buttonCancel: 'Cancelar',
      });
  
      if (userCancell) {
        setIsSubmitting(false);
        return;
      }
  
      const data = {
        amount: 'other',
        other_amount: amount,
        method: 'cash',
      };
      const response = await API.createDepositOrder(data);

      if (response?.data?.success) {
        setOrder(response.data.order);
      } else {
        showModalError({ errorMessage: response.data.error });
      }
    } catch (error) {
      showModalError({ errorMessage: 'Ha ocurrido un error' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.wrapper}>
      {!order && (
        <div className={styles.container}>
          {/* Header con icono y título */}
          <div className={styles.header}>
            <div className={styles.headerIcon}>
              <img src={iconoTienda} alt="Icono pago en tienda" />
            </div>
            <h2 className={styles.headerTitle}>
              Genera tu ficha de depósito{' '}
              <span className={styles.headerTitleHighlight}>para pago en tiendas.</span>
            </h2>
          </div>

          {/* Botón de acción */}
          <div className={styles.buttonContainer}>
            <button
              className="payment-button"
              onClick={processPayment}
              disabled={isSubmitting || isInvalidAmount}
            >
              <span className={styles.buttonText}>Generar tu ficha</span>
              <img
                src={iconoBotonDescargaFicha}
                alt="Icono descargar ficha"
                className={styles.buttonIcon}
              />
            </button>
          </div>

          {/* Advertencia */}
          <div className={styles.warningBox}>
            <img src={iconoDisclaimer} alt="Icono advertencia" className={styles.warningIcon} />
            <div className={styles.warningContent}>
              <div className={styles.warningTitle}>¡RECUERDA!</div>
              <div className={styles.warningText}>
                Los depósitos en tienda pueden tomar hasta 3 horas en verse el saldo reflejado en
                tu cuenta.
              </div>
            </div>
          </div>

          {/* Texto secundario */}
          <div className={styles.secondaryText}>
            <a
              href="https://map.conekta.com/"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.storesLink}
            >
              Consulta las tiendas participantes.
            </a>
          </div>
        </div>
      )}

      {order && (
        <div className={styles.orderInfo}>
          <p className={styles.warningText}>
            Gracias por tu compra, acude a tu tienda más cercana y presenta este código de barras:
          </p>

          <div className="text-center">
            <img
              src={order.charges.data[0].payment_method.barcode_url}
              className={`${styles.barcodeImage}`}
              alt="Código de barras"
            />
          </div>
          <div className={styles.reference}>{order.charges.data[0].payment_method.reference}</div>
          <div className="text-center mb-2">Código para abonar ${amount} MXN </div>
          <div className="text-center text-bold mt-5" style={{ color: '#c7ae0d' }}>
            <a
              href="https://map.conekta.com/"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.mapLink}
            >
              Consulta el mapa de tiendas para realizar tu pago.
            </a>
            <br />
            <a
              href="https://map.conekta.com/"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.mapLink}
            >
              <Iconify
                icon="streamline-flex:map-location-solid"
                style={{ fontSize: '2em', color: '#70c70d', margin: '1rem' }}
              />
            </a>
          </div>

          <div className={styles.buttonContainer}>
            <button
              className="payment-button"
              onClick={processPayment}
              disabled={isSubmitting || isInvalidAmount}
            >
              <span className={styles.buttonText}>
                {isSubmitting
                  ? 'Generando referencia...'
                  : `Generar ${!!order ? ' otra ' : ''} referencia`}
              </span>
              {!isSubmitting && (
                <img
                  src={iconoBotonDescargaFicha}
                  alt="Icono descargar ficha"
                  className={styles.buttonIcon}
                />
              )}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
